import React, { useState } from 'react';
import { Card } from '../ui/card';
import { Badge } from '../ui/badge';
import { Button } from '../ui/button';
import { Table, TableBody, TableHead, TableHeader, TableRow } from '../ui/table';
import { CreditCard, Plus } from 'lucide-react';
import { ClienteCvuFila } from './ClienteCvuFila';
import { CvuFiltrosBar } from './CvuFiltrosBar';
import { CvuResumenActivos } from './CvuResumenActivos';
import { filtrarCvus } from './cvuUtils';

const COLUMNAS = ['CVU', 'Banco sponsor', 'Estado', 'Reemplaza a', 'Origen', 'Alias'];

// Tabla de CVUs de la ficha del cliente, con filtros por banco sponsor y estado.
export const ClienteCvusTabla = ({ cvus, cvuPadron, esAdmin, onAdd, onToggleActivo, onSetPrincipal, onDelete, onVincular }) => {
  const [filtros, setFiltros] = useState({ sponsor: 'todos', estado: 'todos' });
  const visibles = filtrarCvus(cvus, filtros);
  return (
    <Card className="p-6 bg-white border-slate-200" data-testid="cliente-cvus-section">
      <div className="flex flex-wrap items-start justify-between gap-3 mb-3">
        <div className="space-y-1.5">
          <div className="flex items-center gap-2">
            <CreditCard size={20} className="text-blue-600" />
            <h2 className="text-lg font-bold text-slate-900">CVUs del Cliente</h2>
            <Badge className="bg-blue-100 text-blue-800" data-testid="cliente-cvus-total">{cvus.length}</Badge>
          </div>
          <CvuResumenActivos cvus={cvus} testid="cliente-cvus-resumen" />
        </div>
        <Button size="sm" onClick={onAdd} className="bg-blue-600 hover:bg-blue-700 text-white" data-testid="cliente-cvus-agregar">
          <Plus size={14} className="mr-1" /> Agregar CVU
        </Button>
      </div>
      {cvus.length === 0 ? (
        <div className="text-center py-8 text-slate-500" data-testid="cliente-cvus-vacio">
          <CreditCard size={40} className="mx-auto mb-2 opacity-30" />
          <p>No hay CVUs registrados</p>
          <p className="text-sm">El CVU original del padrón: <span className="font-mono">{cvuPadron}</span></p>
        </div>
      ) : (
        <>
          <CvuFiltrosBar cvus={cvus} filtros={filtros} onChange={setFiltros} testid="cliente-cvus-filtros" total={visibles.length} />
          <div className="overflow-auto rounded-lg border mt-3">
            <Table>
              <TableHeader className="bg-slate-50">
                <TableRow>
                  <TableHead className="w-8" />
                  {COLUMNAS.map((c) => <TableHead key={c} className="text-xs">{c}</TableHead>)}
                  <TableHead className="text-xs text-right">Acciones</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {visibles.map((cvu) => {
                  const idx = cvus.indexOf(cvu);
                  return (
                    <ClienteCvuFila key={cvu.id || cvu.numero_limpio || idx} cvu={cvu} idx={idx}
                      tipo={cvu.tipo || (idx === 0 ? 'PRINCIPAL' : 'SECUNDARIO')} puedeBorrar={cvus.length > 1}
                      esAdmin={esAdmin} onToggleActivo={onToggleActivo} onSetPrincipal={onSetPrincipal}
                      onDelete={onDelete} onVincular={cvus.length > 1 ? onVincular : null} />
                  );
                })}
              </TableBody>
            </Table>
            {visibles.length === 0 && (
              <p className="text-center text-sm text-slate-400 py-6" data-testid="cliente-cvus-sin-resultados">Ningún CVU cumple los filtros.</p>
            )}
          </div>
        </>
      )}
    </Card>
  );
};
